export const Endpoint = process.env.REACT_APP_API_URL
export const prefix = 'settlement'
export const settlementConstants = {
    API_INSERT_BY_BANKING: `${Endpoint}/${prefix}/create/bank`,
    API_INSERT_BY_WEB: `${Endpoint}/${prefix}/create/order`,    
    API_GET_BY_BANKING: `${Endpoint}/${prefix}/bank`,
    API_GET_BY_WEB: `${Endpoint}/${prefix}/order`,
    API_EDIT_BY_BANKING: `${Endpoint}/${prefix}/update/bank`,
    API_EDIT_BY_WEB: `${Endpoint}/${prefix}/update/order`,
    API_RECHECK_BY_BANKING: `${Endpoint}/${prefix}/recheck/bank`,
    API_SETTLEMENT_DELETE_FILE: `${Endpoint}/${prefix}/file/delete`,
  
    INSERT_BANKING_SUCCESS: 'SETTLEMENT_INSERT_BANKING_SUCCESS',
    INSERT_BANKING_FAILURE: 'SETTLEMENT_INSERT_BANKING_FAILURE',
    INSERT_WEB_SUCCESS: 'SETTLEMENT_INSERT_WEB_SUCCESS',
    INSERT_WEB_FAILURE: 'SETTLEMENT_INSERT_WEB_FAILURE',
    RECHECK_BANKING_SUCCESS: 'SETTLEMENT_RECHECK_BANKING_SUCCESS',
    RECHECK_BANKING_FAILURE: 'SETTLEMENT_RECHECK_BANKING_FAILURE',
    
    EDIT_BANKING_SUCCESS: 'SETTLEMENT_EDIT_BANKING_SUCCESS',
    EDIT_BANKING_FAILURE: 'SETTLEMENT_EDIT_BANKING_FAILURE',
    EDIT_WEB_SUCCESS: 'SETTLEMENT_EDIT_WEB_SUCCESS',
    EDIT_WEB_FAILURE: 'SETTLEMENT_EDIT_WEB_FAILURE',


    GET_ALL_BANKING: 'SETTLEMENT_GET_ALL_BANKING',
    GET_ALL_WEB: 'SETTLEMENT_GET_ALL_WEB',
    GET_BANKING_SUCCESS: 'SETTLEMENT_GET_BANKING_SUCCESS',
    GET_BANKING_FAILURE: 'SETTLEMENT_GET_BANKING_FAILURE',
    GET_WEB_SUCCESS: 'SETTLEMENT_GET_WEB_SUCCESS',
    GET_WEB_FAILURE: 'SETTLEMENT_GET_WEB_FAILURE',
    GET_MONTHLY_REPORT_SUCCESS: 'SETTLEMENT_GET_MONTHLY_REPORT_SUCCESS',
    GET_MONTHLY_REPORT_FAILURE: 'SETTLEMENT_GET_MONTHLY_REPORT_FAILURE',

    DELETE_FILE_SUCCESS: 'SETTLEMENT_DELETE_FILE_SUCCESS',
    DELETE_FILE_FAILURE: 'SETTLEMENT_DELETE_FILE_FAILURE',

    GET_ALL:    'SETTLEMENT_GET_ALL',
    GET_DATA:   'SETTLEMENT_GET_DATA',
    GET_SELECT: 'SETTLEMENT_GET_SELECT',
    GET_FAILURE:'SETTLEMENT_GET_FAILURE',
    CLEAR_DATA: 'SETTLEMENT_CLEAR_DATA',

    SELECTED_BANKING: 'SELECTED_BANKING',
    SELECTED_WEB: 'SELECTED_WEB'
}